import { MakePaths } from "common/router/types";
import { makeRoutes, MakeRoutesOpts } from "common/router/utils/routes";
import { makeUrls } from "common/router/utils/urls";

import { INITIAL_CLIENT_DATA } from "client/common/utils";

import { HelpCenterSearch } from "../types";

const paths = {
  helpCenter: "/",
  privacyPolicy: "/privacy-policy",
  termsOfUse: "/terms-of-use",
};

type SupportPathDefinitions = {
  helpCenter: { Search: HelpCenterSearch };
  privacyPolicy: {};
  termsOfUse: {};
};

export type SupportPaths = MakePaths<SupportPathDefinitions>;

export const useSupportRoutes = (opts: MakeRoutesOpts) => {
  const isHdEnabled = INITIAL_CLIENT_DATA.clinic.primary_tag.is_hd_enabled;

  const routes = [
    {
      path: paths.helpCenter,
      element: () => import("../components/SupportPage"),
      requiresHd: true,
    },
    { path: paths.privacyPolicy, element: () => import("../components/PrivacyPolicyPage") },
    { path: paths.termsOfUse, element: () => import("../components/TermsOfUsePage") },
  ];

  const filteredRoutes = routes.filter((route) => !route.requiresHd || isHdEnabled);

  return makeRoutes(opts, filteredRoutes);
};

export const makeSupportUrls = (base: string) => {
  return makeUrls<SupportPathDefinitions>(base, {
    helpCenter: { path: paths.helpCenter },
    privacyPolicy: { path: paths.privacyPolicy },
    termsOfUse: { path: paths.termsOfUse },
  });
};
